import { ActionProfilePlanEmergency } from './profile-plan.actions';
import { Injectable, inject } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { ProfileService } from '@app/core/services/profile/profile.service';
import {
    ActionProfilePlanUpdate,
    ProfilePlanActionTypes
} from '@app/profile/profile-remaining-count/profile-plan.actions';
import { PacksActionsTypes } from '@app/certificates/packs/packs.reducer';
import { SigningActionTypes } from '@app/certificates/signing/signing.actions';
import { switchMap, map, tap } from 'rxjs/operators';

import { Observable } from 'rxjs';
import { ISpringResponseBody } from '@app/shared/interfaces/response-interfaces';
import { DownloadActionTypes } from '@app/certificates/signing/download.action';

@Injectable()
export class ProfilePlanEffects {

    private actions$ = inject(Actions<Action>)
    private profileService= inject(ProfileService)

        update$ = createEffect(() => {
            return this.actions$
                .pipe(ofType(ProfilePlanActionTypes.GET,
                    PacksActionsTypes.PAYMENT_SUCCESS,
                    SigningActionTypes.SIGNING_SUCCESS,
                    DownloadActionTypes.DOWNLOAD_ACTION),
                    switchMap(() => {
                        return this.profileService.getRemainingCount();
                    }),
                    map((response: ISpringResponseBody) => {
                        if (response.status === 200) {
                            return new ActionProfilePlanUpdate({ profilePlan: response.data });
                        }
                        return new ActionProfilePlanEmergency();
                    })
                );
        }, { dispatch: true })

}
